import React, { createContext, useContext } from 'react';
import { useModal } from '@/hooks';

const SearchContext = createContext();

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useSearch must be used within SearchProvider');
  }
  return context;
};

export const SearchProvider = ({ children }) => {
  const searchBar = useModal();

  const value = {
    isSearchBarOpen: searchBar.isOpen,
    openSearchBar: searchBar.open,
    closeSearchBar: searchBar.close,
    toggleSearchBar: searchBar.toggle
  };

  return (
    <SearchContext.Provider value={value}>
      {children}
    </SearchContext.Provider>
  );
};